// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Materialize v2 themes its components (select, input, datepicker, etc.) via
 * Material Design 3 design tokens (--md-sys-color-*). The <html theme="dark">
 * attribute activates v2's dark palette; here we remap the tokens that drive
 * component appearance onto KeepTrack's own palette so they match the brand
 * (e.g. red accent instead of v2's default blue) instead of Material defaults.
 */
:root[theme='dark'] {
    --md-sys-color-primary: var(--color-primary);
    --md-sys-color-surface: var(--kt-bg-elevated);
    --md-sys-color-on-surface: var(--kt-text-primary);
    --md-sys-color-background: var(--kt-bg-primary);
    --md-sys-color-on-background: var(--kt-text-primary);
    --md-sys-color-surface-variant: var(--kt-bg-elevated);
    --md-sys-color-on-surface-variant: var(--kt-text-secondary);
    --md-sys-color-outline: var(--kt-border-strong);
    --md-sys-color-outline-variant: var(--kt-border-default);
}

.page-footer {
    background-color: var(--color-dark-background) !important;
}

.spinner-layer {
    border-color: #ffffff !important;
}

.switch label input[type='checkbox']:checked+.lever:after {
    background-color: rgb(255, 255, 255) !important;
}

/* Text inputs */
input:not([type]),
input[type='text']:not(.browser-default),
input[type='password']:not(.browser-default),
input[type='email']:not(.browser-default),
input[type='url']:not(.browser-default),
input[type='time']:not(.browser-default),
input[type='date']:not(.browser-default),
input[type='datetime']:not(.browser-default),
input[type='datetime-local']:not(.browser-default),
input[type='tel']:not(.browser-default),
input[type='number']:not(.browser-default),
input[type='search']:not(.browser-default),
textarea.materialize-textarea {
    border-bottom: 1px solid #ffffff !important;
    color: #ffffff;
    -webkit-appearance: none;
}

.btn,
.btn-large,
.btn-small {
    background-color: var(--color-primary);
}

.btn:hover,
.btn-large:hover,
.btn-small:hover {
    background-color: var(--color-primary-light);
}

.btn:focus,
.btn-large:focus,
.btn-small:focus,
.btn-floating:focus {
    background-color: var(--color-primary-dark);
}

.switch label input[type='checkbox']:checked+.lever {
    background-color: var(--color-primary) !important;
}

.dropdown-content li>a,
.dropdown-content li>span {
    color: var(--color-primary) !important;
    font-size: 14px !important;
}

.toast {
    --kt-toast-accent: #a4abb6;
    border-radius: var(--kt-radius-md, 6px) !important;
    min-height: auto !important;
    padding: 12px 16px !important;
    display: flex !important;
    align-items: center !important;
    gap: 10px !important;
    box-shadow: var(--kt-shadow-lg, 0 8px 24px rgba(0, 0, 0, 0.5)) !important;
    background: rgba(32, 34, 37, 0.97) !important;
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
    border-left: 3px solid var(--kt-toast-accent) !important;
    backdrop-filter: blur(8px);
    animation: kt-toast-enter 200ms cubic-bezier(0, 0, 0.2, 1) !important;
    position: relative;
    overflow: hidden;
    color: rgba(255, 255, 255, 0.95) !important;
}

.toast .kt-toast-icon {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    filter: brightness(0) invert(1);
    opacity: 0.9;
}

.toast .kt-toast-progress {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 2px;
    background: var(--kt-toast-accent);
    opacity: 0.8;
    animation: kt-toast-progress-shrink linear forwards;
}

@keyframes kt-toast-enter {
    from {
        opacity: 0;
        transform: translateY(8px) scale(0.96);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes kt-toast-progress-shrink {
    from { width: 100%; }
    to { width: 0%; }
}

/*
 * Match select triggers to the v1 text-input metrics below: same 3rem height
 * with vertically centered text and no v2 inset padding (20px top / 16px left),
 * so select values align and read exactly like the text fields around them.
 */
.select-wrapper input.select-dropdown {
    height: 3rem !important;
    line-height: 3rem !important;
    padding: 0 !important;
    box-sizing: content-box;
}

/*
 * Materialize v2 form fixes.
 * v2 no longer makes .input-field inputs full-width (the old vendored v1 CSS
 * did), and it floats labels purely via :placeholder-shown adjacency, which
 * KeepTrack's class="active" labels and the select's nested input never
 * trigger. KeepTrack uses always-above labels on transparent fields, so float
 * every input-field label, restore full-width fields (which also pulls the
 * select caret in to the field's right edge), and keep the field background
 * transparent (v2 paints fields with --md-sys-color-surface; we reserve that
 * token's fill for dropdown menus / modals, not the inline fields).
 */
.input-field input,
.input-field textarea,
.input-field .select-wrapper,
.input-field .select-wrapper input.select-dropdown {
    width: 100%;
}

.input-field input,
.input-field textarea,
.input-field .select-wrapper input.select-dropdown,
.input-field .select-wrapper > .hide-select select {
    background-color: transparent !important;
}

.input-field > label {
    top: 0;
    transform: translateY(-14px) scale(0.75);
    transform-origin: 0 0;
    color: var(--color-dark-text-muted);
}

/*
 * v2 floats a filled input's label to top: 8px (inside the field box) via
 * higher-specificity sibling selectors, which collides with the v1-height
 * values restored above. Mirror those selectors to keep every label in the
 * v1 position fully above the field.
 */
.input-field input:focus:not([readonly]) + label,
.input-field input:not([placeholder=' ']) + label,
.input-field input:not(:placeholder-shown) + label,
.input-field textarea:focus:not([readonly]) + label,
.input-field textarea:not([placeholder=' ']) + label,
.input-field textarea:not(:placeholder-shown) + label {
    top: 0;
    transform: translateY(-14px) scale(0.75);
}

/*
 * v2 draws a 2px box outline around a focused select (.select-wrapper:focus-within);
 * KeepTrack (like v1) indicates focus with the field underline instead, so drop the
 * boxed outline.
 */
.select-wrapper:focus-within {
    outline: none;
}

/*
 * v2's FormSelect adds the input-field class to its generated .select-wrapper
 * (v1 added only select-wrapper), so KeepTrack's .input-field margins and
 * padding double-apply inside every select field — doubling vertical spacing
 * and indenting the field twice. Neutralize the nested wrapper.
 */
.input-field .select-wrapper.input-field {
    margin: 0;
    padding: 0;
}

/*
 * Restore v1 text-input metrics. v1 gave text inputs height: 3rem and an 8px
 * bottom margin; v2 sizes them by content (~15px shorter, no margin), which
 * makes dense forms like Create Satellite feel overly compacted. Select
 * triggers (.select-dropdown) are excluded — they keep the v2 padding the
 * select styling above is tuned for.
 */
.input-field input:not([type]):not(.select-dropdown),
.input-field input[type='text']:not(.browser-default):not(.select-dropdown),
.input-field input[type='password']:not(.browser-default),
.input-field input[type='email']:not(.browser-default),
.input-field input[type='url']:not(.browser-default),
.input-field input[type='time']:not(.browser-default),
.input-field input[type='date']:not(.browser-default),
.input-field input[type='datetime']:not(.browser-default),
.input-field input[type='datetime-local']:not(.browser-default),
.input-field input[type='tel']:not(.browser-default),
.input-field input[type='number']:not(.browser-default),
.input-field input[type='search']:not(.browser-default),
.input-field textarea.materialize-textarea {
    height: 3rem;
    margin: 0 0 8px 0;
    padding: 0;
    box-sizing: content-box;
}

/*
 * Restore v1 dropdown colors. v1 dropdown panels were white with #eee hover;
 * v2 paints them with --md-sys-color-surface, which our dark token mapping
 * turns into red-on-dark — unreadable. The red item text comes from the
 * .dropdown-content overrides above, as in v1.
 */
.dropdown-content {
    background-color: #fff;
}

.dropdown-content li:not(.disabled):hover,
.dropdown-content li.active,
body.keyboard-focused .dropdown-content li:focus {
    background-color: #eee;
}

.dropdown-content li.selected {
    background-color: rgba(0, 0, 0, 0.08);
}

/*
 * Multi-select dropdown options. v2 renders them as checkbox labels inside the
 * select wrapper, which carries the input-field class — so generic field-input
 * rules bleed onto the checkbox: width 100% stretches it across the row (turning
 * its round MD3 focus outline into a giant ellipse) and pushes the option text to
 * the far edge, while the app's dark-theme label color renders white-on-white.
 * Restore native checkbox geometry and match the single-select option styling.
 */
.dropdown-content input[type='checkbox'] {
    width: 18px;
    height: 18px;
    padding: 0;
    margin: 0;
    border: none;
    position: relative;
    flex-shrink: 0;
}

/*
 * v2 draws the box on ::before (absolute) but the checkmark on ::after in
 * normal flow (position: relative, display: block), which can drift below the
 * box. Anchor both to the 18px input so they always overlap.
 */
.dropdown-content input[type='checkbox']::before,
.dropdown-content input[type='checkbox']::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 18px;
    height: 18px;
}

.dropdown-content input[type='checkbox']:focus {
    outline: none;
}

.dropdown-content li > span > label {
    display: flex;
    align-items: center;
    gap: 12px;
    height: auto;
    cursor: pointer;
}

.dropdown-content li > span > label,
.dropdown-content [type='checkbox'] + span {
    color: var(--color-primary);
}

/* Unchecked box border is on-surface-variant (near-white) — invisible on the white panel */
.dropdown-content input[type='checkbox']:not(:checked)::before {
    border-color: rgba(0, 0, 0, 0.45);
}

/*
 * v2 makes dropdown options focusable; the app-wide :focus-visible outline
 * (2px offset red) renders as clipped horizontal lines around the focused row
 * inside the panel. Indicate focus with the hover background instead.
 */
.dropdown-content li:focus-visible {
    outline: none;
    background-color: #eee;
}

/*
 * Materialize v2 replaced the v1 float grid with CSS Grid
 * (.row { display: grid; grid-template-columns: repeat(12, 1fr) }). The default
 * 1fr track is minmax(auto, 1fr), which refuses to shrink below its content's
 * min-content, so wide content (long <option> text, buttons) forces the row
 * wider than its fixed-width side-menu container and overflows. minmax(0, 1fr)
 * lets the tracks shrink to fit the menu. gap:0 drops v2's 1.5rem grid gutters
 * (KeepTrack spaces fields with margins, as in v1) so a full-width col spans the
 * menu exactly.
 */
.row {
    margin-bottom: 1rem;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    gap: 0;
}

/*
 * In v1's float grid, plain (non-.col) children of a .row were normal
 * full-width blocks. v2's CSS Grid auto-places any child without a grid-column
 * span (e.g. <div class="center-align"> button wrappers, spacer <div class="row">)
 * into a single ~30px column, so their contents overflow and overlap. Make every
 * non-.col row child span the full width to restore the v1 stacking behavior.
 */
.row > *:not([class*='col']) {
    grid-column: 1 / -1;
}

/*
 * Grid items stretch to their track by default, so a .btn placed directly in a
 * .row becomes full-width (v1's float grid left it content-sized). Size buttons
 * to their content; .center-align rows keep them centered, others left-aligned.
 */
.row > .btn:not([class*='col']),
.row > button:not([class*='col']) {
    justify-self: start;
}

.row.center-align > .btn,
.row.center-align > button {
    justify-self: center;
}

/** non-desktop */
@media (max-width: 1300px) {
    .row {
        margin-left: inherit;
        margin-right: inherit;
    }
}

.input-field {
    margin-top: 1rem 0 0 0;
    padding-left: 1rem;
    padding-right: 1rem;
}

.input-field.col label {
    padding-top: 0px;
}

input:not([type]):focus:not([readonly])+label,
input[type='text']:not(.browser-default):focus:not([readonly])+label,
input[type='password']:not(.browser-default):focus:not([readonly])+label,
input[type='email']:not(.browser-default):focus:not([readonly])+label,
input[type='url']:not(.browser-default):focus:not([readonly])+label,
input[type='time']:not(.browser-default):focus:not([readonly])+label,
input[type='date']:not(.browser-default):focus:not([readonly])+label,
input[type='datetime']:not(.browser-default):focus:not([readonly])+label,
input[type='datetime-local']:not(.browser-default):focus:not([readonly])+label,
input[type='tel']:not(.browser-default):focus:not([readonly])+label,
input[type='number']:not(.browser-default):focus:not([readonly])+label,
input[type='search']:not(.browser-default):focus:not([readonly])+label,
textarea.materialize-textarea:focus:not([readonly])+label {
    color: var(--color-dark-text-accent);
}

input:not([type]):disabled+label,
input:not([type])[readonly='readonly']+label,
input[type='text']:not(.browser-default):disabled+label,
input[type='text']:not(.browser-default)[readonly='readonly']+label,
input[type='password']:not(.browser-default):disabled+label,
input[type='password']:not(.browser-default)[readonly='readonly']+label,
input[type='email']:not(.browser-default):disabled+label,
input[type='email']:not(.browser-default)[readonly='readonly']+label,
input[type='url']:not(.browser-default):disabled+label,
input[type='url']:not(.browser-default)[readonly='readonly']+label,
input[type='time']:not(.browser-default):disabled+label,
input[type='time']:not(.browser-default)[readonly='readonly']+label,
input[type='date']:not(.browser-default):disabled+label,
input[type='date']:not(.browser-default)[readonly='readonly']+label,
input[type='datetime']:not(.browser-default):disabled+label,
input[type='datetime']:not(.browser-default)[readonly='readonly']+label,
input[type='datetime-local']:not(.browser-default):disabled+label,
input[type='datetime-local']:not(.browser-default)[readonly='readonly']+label,
input[type='tel']:not(.browser-default):disabled+label,
input[type='tel']:not(.browser-default)[readonly='readonly']+label,
input[type='number']:not(.browser-default):disabled+label,
input[type='number']:not(.browser-default)[readonly='readonly']+label,
input[type='search']:not(.browser-default):disabled+label,
input[type='search']:not(.browser-default)[readonly='readonly']+label,
textarea.materialize-textarea:disabled+label,
textarea.materialize-textarea[readonly='readonly']+label {
    color: var(--color-dark-text-muted)
}

input:not([type]):disabled,
input:not([type])[readonly='readonly'],
input[type='text']:not(.browser-default):disabled,
input[type='text']:not(.browser-default)[readonly='readonly'],
input[type='password']:not(.browser-default):disabled,
input[type='password']:not(.browser-default)[readonly='readonly'],
input[type='email']:not(.browser-default):disabled,
input[type='email']:not(.browser-default)[readonly='readonly'],
input[type='url']:not(.browser-default):disabled,
input[type='url']:not(.browser-default)[readonly='readonly'],
input[type='time']:not(.browser-default):disabled,
input[type='time']:not(.browser-default)[readonly='readonly'],
input[type='date']:not(.browser-default):disabled,
input[type='date']:not(.browser-default)[readonly='readonly'],
input[type='datetime']:not(.browser-default):disabled,
input[type='datetime']:not(.browser-default)[readonly='readonly'],
input[type='datetime-local']:not(.browser-default):disabled,
input[type='datetime-local']:not(.browser-default)[readonly='readonly'],
input[type='tel']:not(.browser-default):disabled,
input[type='tel']:not(.browser-default)[readonly='readonly'],
input[type='number']:not(.browser-default):disabled,
input[type='number']:not(.browser-default)[readonly='readonly'],
input[type='search']:not(.browser-default):disabled,
input[type='search']:not(.browser-default)[readonly='readonly'],
textarea.materialize-textarea:disabled,
textarea.materialize-textarea[readonly='readonly'] {
    color: var(--color-dark-text-muted)
}

@media only screen and (min-width: 601px) {

    nav,
    nav .nav-wrapper i,
    nav a.sidenav-trigger,
    nav a.sidenav-trigger i {
        height: 64px;
        line-height: 64px;
    }
}`, "",{"version":3,"sources":["webpack://./public/css/materialize-local.css"],"names":[],"mappings":"AAAA;;;;;;EAME;AACF;IACI,4CAA4C;IAC5C,6CAA6C;IAC7C,iDAAiD;IACjD,+CAA+C;IAC/C,oDAAoD;IACpD,qDAAqD;IACrD,2DAA2D;IAC3D,+CAA+C;IAC/C,wDAAwD;AAC5D;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+CAA+C;AACnD;;AAEA,gBAAgB;AAChB;;;;;;;;;;;;;IAaI,2CAA2C;IAC3C,cAAc;IACd,wBAAwB;AAC5B;;AAEA;;;IAGI,sCAAsC;AAC1C;;AAEA;;;IAGI,4CAA4C;AAChD;;AAEA;;;;IAII,2CAA2C;AAC/C;;AAEA;IACI,iDAAiD;AACrD;;AAEA;;IAEI,sCAAsC;IACtC,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,kDAAkD;IAClD,2BAA2B;IAC3B,6BAA6B;IAC7B,wBAAwB;IACxB,8BAA8B;IAC9B,oBAAoB;IACpB,yEAAyE;IACzE,6CAA6C;IAC7C,sDAAsD;IACtD,wDAAwD;IACxD,0BAA0B;IAC1B,qEAAqE;IACrE,kBAAkB;IAClB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,kCAAkC;IAClC,YAAY;IACZ,mDAAmD;AACvD;;AAEA;IACI;QACI,UAAU;QACV,sCAAsC;IAC1C;IACA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA;IACI,OAAO,WAAW,EAAE;IACpB,KAAK,SAAS,EAAE;AACpB;;AAEA;;;;EAIE;AACF;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;;;;;;;;;;EAUE;AACF;;;;IAII,WAAW;AACf;;AAEA;;;;IAII,wCAAwC;AAC5C;;AAEA;IACI,MAAM;IACN,wCAAwC;IACxC,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;;;;;EAKE;AACF;;;;;;IAMI,MAAM;IACN,wCAAwC;AAC5C;;AAEA;;;;EAIE;AACF;IACI,aAAa;AACjB;;AAEA;;;;;EAKE;AACF;IACI,SAAS;IACT,UAAU;AACd;;AAEA;;;;;;EAME;AACF;;;;;;;;;;;;;IAaI,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,uBAAuB;AAC3B;;AAEA;;;;;EAKE;AACF;IACI,sBAAsB;AAC1B;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;;;;;;;EAOE;AACF;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;;;EAIE;AACF;;IAEI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA,2FAA2F;AAC3F;IACI,iCAAiC;AACrC;;AAEA;;;;EAIE;AACF;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;;;;;;;;EASE;AACF;IACI,mBAAmB;IACnB,iDAAiD;IACjD,MAAM;AACV;;AAEA;;;;;;EAME;AACF;IACI,mBAAmB;AACvB;;AAEA;;;;EAIE;AACF;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA,iBAAiB;AACjB;IACI;QACI,oBAAoB;QACpB,qBAAqB;IACzB;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;;;;;;;;;;;IAaI,oCAAoC;AACxC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;IA0BI;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;IA0BI;AACJ;;AAEA;;IAEI;;;;QAII,YAAY;QACZ,iBAAiB;IACrB;AACJ","sourcesContent":["/*\n * Materialize v2 themes its components (select, input, datepicker, etc.) via\n * Material Design 3 design tokens (--md-sys-color-*). The <html theme=\"dark\">\n * attribute activates v2's dark palette; here we remap the tokens that drive\n * component appearance onto KeepTrack's own palette so they match the brand\n * (e.g. red accent instead of v2's default blue) instead of Material defaults.\n */\n:root[theme='dark'] {\n    --md-sys-color-primary: var(--color-primary);\n    --md-sys-color-surface: var(--kt-bg-elevated);\n    --md-sys-color-on-surface: var(--kt-text-primary);\n    --md-sys-color-background: var(--kt-bg-primary);\n    --md-sys-color-on-background: var(--kt-text-primary);\n    --md-sys-color-surface-variant: var(--kt-bg-elevated);\n    --md-sys-color-on-surface-variant: var(--kt-text-secondary);\n    --md-sys-color-outline: var(--kt-border-strong);\n    --md-sys-color-outline-variant: var(--kt-border-default);\n}\n\n.page-footer {\n    background-color: var(--color-dark-background) !important;\n}\n\n.spinner-layer {\n    border-color: #ffffff !important;\n}\n\n.switch label input[type='checkbox']:checked+.lever:after {\n    background-color: rgb(255, 255, 255) !important;\n}\n\n/* Text inputs */\ninput:not([type]),\ninput[type='text']:not(.browser-default),\ninput[type='password']:not(.browser-default),\ninput[type='email']:not(.browser-default),\ninput[type='url']:not(.browser-default),\ninput[type='time']:not(.browser-default),\ninput[type='date']:not(.browser-default),\ninput[type='datetime']:not(.browser-default),\ninput[type='datetime-local']:not(.browser-default),\ninput[type='tel']:not(.browser-default),\ninput[type='number']:not(.browser-default),\ninput[type='search']:not(.browser-default),\ntextarea.materialize-textarea {\n    border-bottom: 1px solid #ffffff !important;\n    color: #ffffff;\n    -webkit-appearance: none;\n}\n\n.btn,\n.btn-large,\n.btn-small {\n    background-color: var(--color-primary);\n}\n\n.btn:hover,\n.btn-large:hover,\n.btn-small:hover {\n    background-color: var(--color-primary-light);\n}\n\n.btn:focus,\n.btn-large:focus,\n.btn-small:focus,\n.btn-floating:focus {\n    background-color: var(--color-primary-dark);\n}\n\n.switch label input[type='checkbox']:checked+.lever {\n    background-color: var(--color-primary) !important;\n}\n\n.dropdown-content li>a,\n.dropdown-content li>span {\n    color: var(--color-primary) !important;\n    font-size: 14px !important;\n}\n\n.toast {\n    --kt-toast-accent: #a4abb6;\n    border-radius: var(--kt-radius-md, 6px) !important;\n    min-height: auto !important;\n    padding: 12px 16px !important;\n    display: flex !important;\n    align-items: center !important;\n    gap: 10px !important;\n    box-shadow: var(--kt-shadow-lg, 0 8px 24px rgba(0, 0, 0, 0.5)) !important;\n    background: rgba(32, 34, 37, 0.97) !important;\n    border: 1px solid rgba(255, 255, 255, 0.08) !important;\n    border-left: 3px solid var(--kt-toast-accent) !important;\n    backdrop-filter: blur(8px);\n    animation: kt-toast-enter 200ms cubic-bezier(0, 0, 0.2, 1) !important;\n    position: relative;\n    overflow: hidden;\n    color: rgba(255, 255, 255, 0.95) !important;\n}\n\n.toast .kt-toast-icon {\n    width: 18px;\n    height: 18px;\n    flex-shrink: 0;\n    filter: brightness(0) invert(1);\n    opacity: 0.9;\n}\n\n.toast .kt-toast-progress {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    height: 2px;\n    background: var(--kt-toast-accent);\n    opacity: 0.8;\n    animation: kt-toast-progress-shrink linear forwards;\n}\n\n@keyframes kt-toast-enter {\n    from {\n        opacity: 0;\n        transform: translateY(8px) scale(0.96);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n@keyframes kt-toast-progress-shrink {\n    from { width: 100%; }\n    to { width: 0%; }\n}\n\n/*\n * Match select triggers to the v1 text-input metrics below: same 3rem height\n * with vertically centered text and no v2 inset padding (20px top / 16px left),\n * so select values align and read exactly like the text fields around them.\n */\n.select-wrapper input.select-dropdown {\n    height: 3rem !important;\n    line-height: 3rem !important;\n    padding: 0 !important;\n    box-sizing: content-box;\n}\n\n/*\n * Materialize v2 form fixes.\n * v2 no longer makes .input-field inputs full-width (the old vendored v1 CSS\n * did), and it floats labels purely via :placeholder-shown adjacency, which\n * KeepTrack's class=\"active\" labels and the select's nested input never\n * trigger. KeepTrack uses always-above labels on transparent fields, so float\n * every input-field label, restore full-width fields (which also pulls the\n * select caret in to the field's right edge), and keep the field background\n * transparent (v2 paints fields with --md-sys-color-surface; we reserve that\n * token's fill for dropdown menus / modals, not the inline fields).\n */\n.input-field input,\n.input-field textarea,\n.input-field .select-wrapper,\n.input-field .select-wrapper input.select-dropdown {\n    width: 100%;\n}\n\n.input-field input,\n.input-field textarea,\n.input-field .select-wrapper input.select-dropdown,\n.input-field .select-wrapper > .hide-select select {\n    background-color: transparent !important;\n}\n\n.input-field > label {\n    top: 0;\n    transform: translateY(-14px) scale(0.75);\n    transform-origin: 0 0;\n    color: var(--color-dark-text-muted);\n}\n\n/*\n * v2 floats a filled input's label to top: 8px (inside the field box) via\n * higher-specificity sibling selectors, which collides with the v1-height\n * values restored above. Mirror those selectors to keep every label in the\n * v1 position fully above the field.\n */\n.input-field input:focus:not([readonly]) + label,\n.input-field input:not([placeholder=' ']) + label,\n.input-field input:not(:placeholder-shown) + label,\n.input-field textarea:focus:not([readonly]) + label,\n.input-field textarea:not([placeholder=' ']) + label,\n.input-field textarea:not(:placeholder-shown) + label {\n    top: 0;\n    transform: translateY(-14px) scale(0.75);\n}\n\n/*\n * v2 draws a 2px box outline around a focused select (.select-wrapper:focus-within);\n * KeepTrack (like v1) indicates focus with the field underline instead, so drop the\n * boxed outline.\n */\n.select-wrapper:focus-within {\n    outline: none;\n}\n\n/*\n * v2's FormSelect adds the input-field class to its generated .select-wrapper\n * (v1 added only select-wrapper), so KeepTrack's .input-field margins and\n * padding double-apply inside every select field — doubling vertical spacing\n * and indenting the field twice. Neutralize the nested wrapper.\n */\n.input-field .select-wrapper.input-field {\n    margin: 0;\n    padding: 0;\n}\n\n/*\n * Restore v1 text-input metrics. v1 gave text inputs height: 3rem and an 8px\n * bottom margin; v2 sizes them by content (~15px shorter, no margin), which\n * makes dense forms like Create Satellite feel overly compacted. Select\n * triggers (.select-dropdown) are excluded — they keep the v2 padding the\n * select styling above is tuned for.\n */\n.input-field input:not([type]):not(.select-dropdown),\n.input-field input[type='text']:not(.browser-default):not(.select-dropdown),\n.input-field input[type='password']:not(.browser-default),\n.input-field input[type='email']:not(.browser-default),\n.input-field input[type='url']:not(.browser-default),\n.input-field input[type='time']:not(.browser-default),\n.input-field input[type='date']:not(.browser-default),\n.input-field input[type='datetime']:not(.browser-default),\n.input-field input[type='datetime-local']:not(.browser-default),\n.input-field input[type='tel']:not(.browser-default),\n.input-field input[type='number']:not(.browser-default),\n.input-field input[type='search']:not(.browser-default),\n.input-field textarea.materialize-textarea {\n    height: 3rem;\n    margin: 0 0 8px 0;\n    padding: 0;\n    box-sizing: content-box;\n}\n\n/*\n * Restore v1 dropdown colors. v1 dropdown panels were white with #eee hover;\n * v2 paints them with --md-sys-color-surface, which our dark token mapping\n * turns into red-on-dark — unreadable. The red item text comes from the\n * .dropdown-content overrides above, as in v1.\n */\n.dropdown-content {\n    background-color: #fff;\n}\n\n.dropdown-content li:not(.disabled):hover,\n.dropdown-content li.active,\nbody.keyboard-focused .dropdown-content li:focus {\n    background-color: #eee;\n}\n\n.dropdown-content li.selected {\n    background-color: rgba(0, 0, 0, 0.08);\n}\n\n/*\n * Multi-select dropdown options. v2 renders them as checkbox labels inside the\n * select wrapper, which carries the input-field class — so generic field-input\n * rules bleed onto the checkbox: width 100% stretches it across the row (turning\n * its round MD3 focus outline into a giant ellipse) and pushes the option text to\n * the far edge, while the app's dark-theme label color renders white-on-white.\n * Restore native checkbox geometry and match the single-select option styling.\n */\n.dropdown-content input[type='checkbox'] {\n    width: 18px;\n    height: 18px;\n    padding: 0;\n    margin: 0;\n    border: none;\n    position: relative;\n    flex-shrink: 0;\n}\n\n/*\n * v2 draws the box on ::before (absolute) but the checkmark on ::after in\n * normal flow (position: relative, display: block), which can drift below the\n * box. Anchor both to the 18px input so they always overlap.\n */\n.dropdown-content input[type='checkbox']::before,\n.dropdown-content input[type='checkbox']::after {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 18px;\n    height: 18px;\n}\n\n.dropdown-content input[type='checkbox']:focus {\n    outline: none;\n}\n\n.dropdown-content li > span > label {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    height: auto;\n    cursor: pointer;\n}\n\n.dropdown-content li > span > label,\n.dropdown-content [type='checkbox'] + span {\n    color: var(--color-primary);\n}\n\n/* Unchecked box border is on-surface-variant (near-white) — invisible on the white panel */\n.dropdown-content input[type='checkbox']:not(:checked)::before {\n    border-color: rgba(0, 0, 0, 0.45);\n}\n\n/*\n * v2 makes dropdown options focusable; the app-wide :focus-visible outline\n * (2px offset red) renders as clipped horizontal lines around the focused row\n * inside the panel. Indicate focus with the hover background instead.\n */\n.dropdown-content li:focus-visible {\n    outline: none;\n    background-color: #eee;\n}\n\n/*\n * Materialize v2 replaced the v1 float grid with CSS Grid\n * (.row { display: grid; grid-template-columns: repeat(12, 1fr) }). The default\n * 1fr track is minmax(auto, 1fr), which refuses to shrink below its content's\n * min-content, so wide content (long <option> text, buttons) forces the row\n * wider than its fixed-width side-menu container and overflows. minmax(0, 1fr)\n * lets the tracks shrink to fit the menu. gap:0 drops v2's 1.5rem grid gutters\n * (KeepTrack spaces fields with margins, as in v1) so a full-width col spans the\n * menu exactly.\n */\n.row {\n    margin-bottom: 1rem;\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n    gap: 0;\n}\n\n/*\n * In v1's float grid, plain (non-.col) children of a .row were normal\n * full-width blocks. v2's CSS Grid auto-places any child without a grid-column\n * span (e.g. <div class=\"center-align\"> button wrappers, spacer <div class=\"row\">)\n * into a single ~30px column, so their contents overflow and overlap. Make every\n * non-.col row child span the full width to restore the v1 stacking behavior.\n */\n.row > *:not([class*='col']) {\n    grid-column: 1 / -1;\n}\n\n/*\n * Grid items stretch to their track by default, so a .btn placed directly in a\n * .row becomes full-width (v1's float grid left it content-sized). Size buttons\n * to their content; .center-align rows keep them centered, others left-aligned.\n */\n.row > .btn:not([class*='col']),\n.row > button:not([class*='col']) {\n    justify-self: start;\n}\n\n.row.center-align > .btn,\n.row.center-align > button {\n    justify-self: center;\n}\n\n/** non-desktop */\n@media (max-width: 1300px) {\n    .row {\n        margin-left: inherit;\n        margin-right: inherit;\n    }\n}\n\n.input-field {\n    margin-top: 1rem 0 0 0;\n    padding-left: 1rem;\n    padding-right: 1rem;\n}\n\n.input-field.col label {\n    padding-top: 0px;\n}\n\ninput:not([type]):focus:not([readonly])+label,\ninput[type='text']:not(.browser-default):focus:not([readonly])+label,\ninput[type='password']:not(.browser-default):focus:not([readonly])+label,\ninput[type='email']:not(.browser-default):focus:not([readonly])+label,\ninput[type='url']:not(.browser-default):focus:not([readonly])+label,\ninput[type='time']:not(.browser-default):focus:not([readonly])+label,\ninput[type='date']:not(.browser-default):focus:not([readonly])+label,\ninput[type='datetime']:not(.browser-default):focus:not([readonly])+label,\ninput[type='datetime-local']:not(.browser-default):focus:not([readonly])+label,\ninput[type='tel']:not(.browser-default):focus:not([readonly])+label,\ninput[type='number']:not(.browser-default):focus:not([readonly])+label,\ninput[type='search']:not(.browser-default):focus:not([readonly])+label,\ntextarea.materialize-textarea:focus:not([readonly])+label {\n    color: var(--color-dark-text-accent);\n}\n\ninput:not([type]):disabled+label,\ninput:not([type])[readonly='readonly']+label,\ninput[type='text']:not(.browser-default):disabled+label,\ninput[type='text']:not(.browser-default)[readonly='readonly']+label,\ninput[type='password']:not(.browser-default):disabled+label,\ninput[type='password']:not(.browser-default)[readonly='readonly']+label,\ninput[type='email']:not(.browser-default):disabled+label,\ninput[type='email']:not(.browser-default)[readonly='readonly']+label,\ninput[type='url']:not(.browser-default):disabled+label,\ninput[type='url']:not(.browser-default)[readonly='readonly']+label,\ninput[type='time']:not(.browser-default):disabled+label,\ninput[type='time']:not(.browser-default)[readonly='readonly']+label,\ninput[type='date']:not(.browser-default):disabled+label,\ninput[type='date']:not(.browser-default)[readonly='readonly']+label,\ninput[type='datetime']:not(.browser-default):disabled+label,\ninput[type='datetime']:not(.browser-default)[readonly='readonly']+label,\ninput[type='datetime-local']:not(.browser-default):disabled+label,\ninput[type='datetime-local']:not(.browser-default)[readonly='readonly']+label,\ninput[type='tel']:not(.browser-default):disabled+label,\ninput[type='tel']:not(.browser-default)[readonly='readonly']+label,\ninput[type='number']:not(.browser-default):disabled+label,\ninput[type='number']:not(.browser-default)[readonly='readonly']+label,\ninput[type='search']:not(.browser-default):disabled+label,\ninput[type='search']:not(.browser-default)[readonly='readonly']+label,\ntextarea.materialize-textarea:disabled+label,\ntextarea.materialize-textarea[readonly='readonly']+label {\n    color: var(--color-dark-text-muted)\n}\n\ninput:not([type]):disabled,\ninput:not([type])[readonly='readonly'],\ninput[type='text']:not(.browser-default):disabled,\ninput[type='text']:not(.browser-default)[readonly='readonly'],\ninput[type='password']:not(.browser-default):disabled,\ninput[type='password']:not(.browser-default)[readonly='readonly'],\ninput[type='email']:not(.browser-default):disabled,\ninput[type='email']:not(.browser-default)[readonly='readonly'],\ninput[type='url']:not(.browser-default):disabled,\ninput[type='url']:not(.browser-default)[readonly='readonly'],\ninput[type='time']:not(.browser-default):disabled,\ninput[type='time']:not(.browser-default)[readonly='readonly'],\ninput[type='date']:not(.browser-default):disabled,\ninput[type='date']:not(.browser-default)[readonly='readonly'],\ninput[type='datetime']:not(.browser-default):disabled,\ninput[type='datetime']:not(.browser-default)[readonly='readonly'],\ninput[type='datetime-local']:not(.browser-default):disabled,\ninput[type='datetime-local']:not(.browser-default)[readonly='readonly'],\ninput[type='tel']:not(.browser-default):disabled,\ninput[type='tel']:not(.browser-default)[readonly='readonly'],\ninput[type='number']:not(.browser-default):disabled,\ninput[type='number']:not(.browser-default)[readonly='readonly'],\ninput[type='search']:not(.browser-default):disabled,\ninput[type='search']:not(.browser-default)[readonly='readonly'],\ntextarea.materialize-textarea:disabled,\ntextarea.materialize-textarea[readonly='readonly'] {\n    color: var(--color-dark-text-muted)\n}\n\n@media only screen and (min-width: 601px) {\n\n    nav,\n    nav .nav-wrapper i,\n    nav a.sidenav-trigger,\n    nav a.sidenav-trigger i {\n        height: 64px;\n        line-height: 64px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
